module.exports = __webpack_public_path__ + "img/c2.91e5fcd3.png";